import { render, staticRenderFns } from "./kindergarten.vue?vue&type=template&id=1672a4a0&scoped=true"
import script from "./kindergarten.vue?vue&type=script&lang=js"
export * from "./kindergarten.vue?vue&type=script&lang=js"
import style0 from "./kindergarten.vue?vue&type=style&index=0&id=1672a4a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1672a4a0",
  null
  
)

export default component.exports